package com.example.mystybag.appCore.views

import androidx.compose.runtime.Composable
import com.example.mystybag.appCore.logic.MystyBagDigitalWalletViewModel
import com.example.mystybag.appCore.logic.MainViewModel
import com.example.mystybag.appCore.logic.NotificationsViewModel
import com.example.mystybag.appCore.logic.pages.NotificationSettingsViewModel
import com.example.mystybag.appCore.logic.pages.SettingsPageViewModel
import com.example.mystybag.appCore.logic.pages.StoredCardsViewModel
import com.example.mystybag.appCore.logic.pages.BagViewModel
import com.example.mystybag.appCore.logic.DeleteAccountRequestViewModel
import com.example.mystybag.appCore.logic.PersonalDetailsViewModel
import com.example.mystybag.appCore.logic.pages.ProfilePageViewModel
import com.example.mystybag.appCore.logic.pages.FilterResultsBottomSheetViewModel
import com.example.mystybag.appCore.logic.pages.ReservationDetailsBottomSheetViewModel
import com.example.mystybag.appCore.logic.pages.AddBagViewModel
import com.example.mystybag.appCore.logic.pages.MerchantLocationsListViewModel
import com.example.mystybag.appCore.logic.pages.MerchantLocationDetailsViewModel
import com.example.mystybag.appCore.logic.pages.MerchantProfileDetailsViewModel
import com.example.mystybag.appCore.logic.pages.StaffListViewModel
import com.example.mystybag.appCore.logic.pages.AddEmployeeViewModel
import com.example.mystybag.appCore.logic.pages.EditEmployeeViewModel
import com.example.mystybag.appCore.logic.pages.CompanyResponsiblePersonsListViewModel
import com.example.mystybag.appCore.logic.pages.CompanyResponsiblePersonEditViewModel
import com.example.mystybag.appCore.logic.pages.ContactsViewModel
import com.example.mystybag.appCore.logic.pages.StatementsViewModel
import com.example.mystybag.appCore.logic.pages.CategoryBagsListViewModel
import com.example.mystybag.appCore.logic.pages.LanguageSelectionBottomSheetViewModel
import com.example.mystybag.appCore.logic.pages.LeaveReviewViewModel
import com.example.mystybag.appCore.logic.addMerchantLocation.MerchantRegistrationAddMerchantLocationDetailsViewModel
import com.example.mystybag.appCore.logic.addMerchantLocation.MerchantRegistrationReviewStoreDetailsViewModel
import com.example.mystybag.appCore.logic.addMerchantLocation.MerchantRegistrationAddDescriptionViewModel
import com.example.mystybag.appCore.logic.addMerchantLocation.MerchantRegistrationMenuPhotosViewModel
import com.example.mystybag.appCore.views.pages.BagView
import com.example.mystybag.appCore.views.pages.ProfilePageView
import com.example.mystybag.appCore.views.pages.AddBagView
import com.example.mystybag.appCore.views.pages.MerchantLocationsListView
import com.example.mystybag.appCore.views.pages.MerchantLocationDetailsView
import com.example.mystybag.appCore.views.pages.MerchantProfileDetailsView
import com.example.mystybag.appCore.views.pages.StaffListView
import com.example.mystybag.appCore.views.pages.AddEmployeeView
import com.example.mystybag.appCore.views.pages.EditEmployeeView
import com.example.mystybag.appCore.views.pages.CompanyResponsiblePersonsListView
import com.example.mystybag.appCore.views.pages.CompanyResponsiblePersonEditView
import com.example.mystybag.appCore.views.pages.ContactsView
import com.example.mystybag.appCore.views.pages.StatementsView
import com.example.mystybag.appCore.views.pages.CategoryBagsListView
import com.example.mystybag.appCore.views.pages.FilterResultsBottomSheetView
import com.example.mystybag.appCore.views.pages.ReservationDetailsBottomSheetView
import com.example.mystybag.appCore.views.pages.LeaveReviewView
import com.example.mystybag.appCore.views.pages.SettingsPageView
import com.example.mystybag.appCore.views.pages.StoredCardsView
import com.example.mystybag.appCore.views.addMerchantLocation.MerchantRegistrationAddMerchantLocationDetailsView
import com.example.mystybag.appCore.views.addMerchantLocation.MerchantRegistrationReviewStoreDetailsView
import com.example.mystybag.appCore.views.addMerchantLocation.MerchantRegistrationAddDescriptionView
import com.example.mystybag.appCore.views.addMerchantLocation.MerchantRegistrationMenuPhotosView
import com.example.mystybag.cropImage.logic.ProfileImageCropperViewModel
import com.example.mystybag.cropImage.views.ProfileImageCropperView
import com.example.mystybag.appCore.logic.FilterResultsBottomSheetChild
import com.example.mystybag.appCore.logic.LanguageSelectionBottomSheetChild
import com.example.mystybag.appCore.logic.ReservationDetailsBottomSheetChild
import com.example.mystybag.common.logic.InternetTroubleshootingViewModel
import com.example.mystybag.common.ui.views.AppView
import com.example.mystybag.common.views.CommonBottomSheetFactory
import com.example.mystybag.common.views.CommonViews
import com.example.mystybag.common.views.InternetTroubleshootingView
import com.example.mystybag.core.expected.PlatformHelper.PlatformView
import com.example.mystybag.login.logic.FeatureLoginAndRegistrationViewModel
import com.example.mystybag.login.views.FeatureViewLoginAndRegistration
import com.example.mystybag.permissionsUtils.expected.PermissionHelper.PermissionView
import com.example.mystybag.url.logic.URLViewViewModel
import com.example.mystybag.url.views.URLView

@Composable
fun FeatureViewMystyBag(model: MystyBagDigitalWalletViewModel) {
    PermissionView()
    PlatformView()

    AppView(
        viewModelInterface       = model.getViewInterface(),
        appScreenFactory         = {
            when (it) {
                is InternetTroubleshootingViewModel         -> InternetTroubleshootingView(it)
                is FeatureLoginAndRegistrationViewModel     -> FeatureViewLoginAndRegistration(it)
                is MainViewModel                            -> MainView(it)
                is NotificationsViewModel                   -> NotificationsView(it)
                is NotificationSettingsViewModel              -> NotificationSettingsView(it)
                is SettingsPageViewModel                      -> SettingsPageView(it)
                is StoredCardsViewModel                       -> StoredCardsView(it)
                is BagViewModel                             -> BagView(it)
                is LeaveReviewViewModel -> LeaveReviewView(it)
                is ProfilePageViewModel                     -> ProfilePageView(it)
                is PersonalDetailsViewModel                  -> PersonalDetailsView(it)
                is DeleteAccountRequestViewModel             -> DeleteAccountRequestView(it)
                is AddBagViewModel                          -> AddBagView(it)
                // Merchant Location registration steps
                is MerchantRegistrationAddMerchantLocationDetailsViewModel -> MerchantRegistrationAddMerchantLocationDetailsView(it)
                is MerchantRegistrationReviewStoreDetailsViewModel -> MerchantRegistrationReviewStoreDetailsView(it)
                is MerchantRegistrationAddDescriptionViewModel -> MerchantRegistrationAddDescriptionView(it)
                is MerchantRegistrationMenuPhotosViewModel -> MerchantRegistrationMenuPhotosView(it)
                is ProfileImageCropperViewModel -> ProfileImageCropperView(it)
                // Merchant Locations
                is MerchantLocationsListViewModel -> MerchantLocationsListView(it)
                is MerchantLocationDetailsViewModel -> MerchantLocationDetailsView(it)
                // Merchant Profile
                is MerchantProfileDetailsViewModel -> MerchantProfileDetailsView(it)
                // Staff list (merchant only)
                is StaffListViewModel -> StaffListView(it)
                // Add Employee (merchant only)
                is AddEmployeeViewModel -> AddEmployeeView(it)
                // Edit Employee (merchant only)
                is EditEmployeeViewModel -> EditEmployeeView(it)
                // Company Responsible Persons (merchant only)
                is CompanyResponsiblePersonsListViewModel -> CompanyResponsiblePersonsListView(it)
                is CompanyResponsiblePersonEditViewModel -> CompanyResponsiblePersonEditView(it)
                // Contacts
                is ContactsViewModel -> ContactsView(it)
                is StatementsViewModel -> StatementsView(it)
                // Category Bags List
                is CategoryBagsListViewModel -> CategoryBagsListView(it)
                /*is SettingsAndNotificationsParentViewModel          -> SettingsAndNotificationsParentView(
                    viewModel
                )*/
                is URLViewViewModel -> URLView(it)
                //is ImageCropperViewModel                            -> ImageCropperView(viewModel)

                else                                                -> CommonViews(it)
            }
        },
        bottomSheetScreenFactory = {
            when (it) {
                is ReservationDetailsBottomSheetChild -> {
                    it.viewModel?.let { viewModel ->
                        ReservationDetailsBottomSheetView(viewModel as ReservationDetailsBottomSheetViewModel)
                    }
                }
                is FilterResultsBottomSheetChild -> {
                    it.viewModel?.let { vm ->
                        FilterResultsBottomSheetView(vm as FilterResultsBottomSheetViewModel)
                    }
                }
                is LanguageSelectionBottomSheetChild -> {
                    it.viewModel?.let { vm ->
                        LanguageSelectionBottomSheetView(vm as LanguageSelectionBottomSheetViewModel)
                    }
                }
              //  is LimitedAccessBottomSheetChild -> LimitedAccessBottomSheetView(it.viewModel)
                else                                        -> CommonBottomSheetFactory(it)
            }
        }
    )
}